var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import cxs from 'cxs';
// Calcular el porcentaje de ocupación
var getOccupancyPercent = function (slot) {
    var totalSold = slot.sold.own + Object.values(slot.sold.external).reduce(function (a, b) { return a + b; }, 0) + slot.sold.collaborator;
    var percent = (totalSold / slot.capacity) * 100;
    return Math.min(Math.round(percent), 100);
};
// Obtener el color de la barra según porcentaje
var getProgressColor = function (percent, hasOverbooking) {
    if (hasOverbooking) {
        return '#dc3545'; // Rojo
    }
    if (percent >= 80) {
        return '#fd7e14'; // Naranja
    }
    if (percent >= 50) {
        return '#ffc107'; // Amarillo
    }
    return '#28a745'; // Verde
};
var styles = {
    card: cxs({
        padding: '8px 10px 12px 10px',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'transform 0.1s, box-shadow 0.1s',
        border: '1px solid rgba(0,0,0,0.1)',
        position: 'relative',
        overflow: 'hidden',
        ':hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        },
    }),
    cardClosed: cxs({
        opacity: 0.6,
    }),
    time: cxs({
        fontSize: '0.85rem',
        fontWeight: 600,
        color: '#333',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    }),
    lockIcon: cxs({
        fontSize: '0.75rem',
    }),
    occupancy: cxs({
        fontSize: '0.8rem',
        color: '#555',
        marginTop: '4px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    }),
    sold: cxs({
        fontWeight: 500,
    }),
    available: cxs({
        color: '#6c757d',
    }),
    groupName: cxs({
        fontSize: '0.75rem',
        fontWeight: 600,
        color: '#6a1b9a',
        marginTop: '4px',
        lineHeight: 1.2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }),
    overbookingBadge: cxs({
        fontSize: '0.7rem',
        backgroundColor: '#dc3545',
        color: '#fff',
        padding: '2px 6px',
        borderRadius: '3px',
        marginTop: '4px',
        display: 'inline-block',
        fontWeight: 600,
    }),
    blockedInfo: cxs({
        fontSize: '0.7rem',
        color: '#856404',
        marginTop: '2px',
    }),
    progressBarContainer: cxs({
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '2px',
        backgroundColor: 'rgba(0,0,0,0.1)',
    }),
    progressBar: cxs({
        height: '100%',
        transition: 'width 0.3s ease',
    }),
};
var SlotCard = /** @class */ (function (_super) {
    __extends(SlotCard, _super);
    function SlotCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SlotCard.prototype.render = function () {
        var _a = this.props, slot = _a.slot, backgroundColor = _a.backgroundColor, onClick = _a.onClick;
        var totalSold = slot.sold.own + slot.sold.collaborator + Object.values(slot.sold.external).reduce(function (a, b) { return a + b; }, 0);
        var occupancyPercent = getOccupancyPercent(slot);
        var progressColor = getProgressColor(occupancyPercent, slot.hasOverbooking);
        var overbookingAmount = totalSold + slot.blocked - slot.capacity;
        // Para overbooking, mostrar barra al 100%
        var displayPercent = slot.hasOverbooking ? 100 : occupancyPercent;
        var cardClass = slot.salesOpen
            ? styles.card
            : "".concat(styles.card, " ").concat(styles.cardClosed);
        return (React.createElement("div", { className: cardClass, style: { backgroundColor: backgroundColor }, onClick: onClick, role: "button", tabIndex: 0 },
            React.createElement("div", { className: styles.time },
                !slot.salesOpen && React.createElement("span", { className: styles.lockIcon }, "\uD83D\uDD12"),
                slot.time),
            React.createElement("div", { className: styles.occupancy },
                React.createElement("span", { className: styles.sold },
                    "\u25A0 ",
                    totalSold),
                React.createElement("span", { className: styles.available },
                    "\u2610 ",
                    slot.available)),
            slot.blocked > 0 && (React.createElement("div", { className: styles.blockedInfo },
                "\uD83D\uDD36 ",
                slot.blocked,
                " bloqueadas")),
            slot.groupName && (React.createElement("div", { className: styles.groupName, title: slot.groupName }, slot.groupName)),
            slot.hasOverbooking && (React.createElement("div", { className: styles.overbookingBadge },
                "Overbooking +",
                overbookingAmount)),
            React.createElement("div", { className: styles.progressBarContainer },
                React.createElement("div", { className: styles.progressBar, style: {
                        width: "".concat(displayPercent, "%"),
                        backgroundColor: progressColor,
                    } }))));
    };
    SlotCard = __decorate([
        observer
    ], SlotCard);
    return SlotCard;
}(Component));
export default SlotCard;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/SlotCard.tsx
// module id = 1612
// module chunks = 0